
import { Component, OnInit, Input } from '@angular/core';
import { SLEntity, SLEntityField } from '../entity';
import { DossierModel } from '../../../dossier-model/dossier-model';
import { buildExtraFields, Field } from './utils';
import { forEach } from 'lodash';

@Component({
  selector: 'sl-entity-extra-fields-panel',
  templateUrl: './entity-extra-fields-panel.component.html',
})
export class SLEntityExtraFieldsPanelComponent implements OnInit {
  
  @Input()
  entity: SLEntity
  
  @Input()
  dossierModel: DossierModel
  
  fields: Field[];

  constructor(
    ) { }
    
  ngOnInit() {
    const extraFieldsMap = {};

    forEach(this.entity.extraFields, field => {
      extraFieldsMap[field.name] = field;
    });

    this.fields = buildExtraFields(this.dossierModel, this.entity.type);

    for (let field of this.fields) {
      const model = extraFieldsMap[field.key] || new SLEntityField({
        name: field.key,
        value: '',
      });

      field.model = model;
    }
  }
}
